import { Sparkles, Unlock, ShieldCheck, Clock } from "lucide-react";
import { GUARANTEES } from "@/data/site";

const ICONS = { sparkles: Sparkles, unlock: Unlock, "shield-check": ShieldCheck, clock: Clock };

export const Guarantees = () => (
  <section data-testid="guarantees" className="border-y border-[#E2ECEE] bg-white">
    <div className="mx-auto grid max-w-7xl gap-6 px-5 py-10 sm:grid-cols-2 lg:grid-cols-4 lg:px-8">
      {GUARANTEES.map((g) => {
        const Icon = ICONS[g.icon];
        return (
          <div key={g.title} className="flex gap-3.5">
            <div className="grid h-11 w-11 flex-none place-items-center rounded-2xl bg-[#0E9E96]/10 text-[#0E9E96]">
              <Icon className="h-5 w-5" />
            </div>
            <div>
              <h3 className="font-head text-base font-extrabold text-slate-900">{g.title}</h3>
              <p className="mt-0.5 text-sm leading-snug text-slate-500">{g.desc}</p>
            </div>
          </div>
        );
      })}
    </div>
  </section>
);
